.language_select {
  min-width: 120px;
}
